import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import AlertWarning from "components/Alerts/AlertWarning"
import AuctionPrice from "components/Auction/AuctionPrice"
import Countdown from "components/Countdown"
import {Auction, Vehicle} from "domain-models"
import {make} from "filters"
import {useAuctionSettings} from "hooks/StateHooks"
import React from "react"
import {hideAuction} from "redux/actions"
import {store} from "store"
import AuctionType from "../AuctionType"
import Attributes from "./Details/Attributes"
import Condition from "./Details/Condition"
import Description from "./Details/Description"
import Equipment from "./Details/Equipment"
import Images from "./Details/Images"
import Remarks from "./Details/Remarks"
import LegalText from "./Details/LegalText"
import Documents from "./Documents"
import IgnoreButton from "./IgnoreButton"
import NavigationButtons from "./NavigationButtons"
import Protocol from "./Protocol"
import WatchButton from "../WatchButton"
import {connect} from "react-redux"
import {GlobalState} from "../../../../state"
import _ from "lodash"
import Trans from '../../../../components/Trans'

type AuctionDetailsProps = {
  auction: Auction
  showDetails: boolean
  toggleDetails: () => void
  close: () => void
  domain: string
}

type State = {
  vehicle: Vehicle
}

class Details extends React.Component<AuctionDetailsProps, State> {
  constructor(props: AuctionDetailsProps) {
    super(props)

    this.state = {
      vehicle: _.first(props.auction.subjects)?.vehicle as Vehicle || _.first(props.auction.subjects)?.leading || _.first(props.auction.subjects)?.leasing
    }
  }

  private settings = useAuctionSettings()
  hideAuction = () => {
    store.dispatch(hideAuction())
  }

  render() {
    const {auction} = this.props

    return (
      <div className='w-full h-full flex flex-col'>
        <div className="flex flex-row justify-between p-2 shadow">
          <div>
            <button onClick={this.hideAuction}><Icon icon='arrow-left'/> Zurück</button>
          </div>
          <div className="flex justify-end">
            <NavigationButtons showDetails={this.props.showDetails} toggleDetails={this.props.toggleDetails}/>
            <span className="p-1"/>
            <WatchButton auction={auction}/>
          </div>
        </div>

        <div className="w-full h-full overflow-scroll scrollbar p-2">
          <div className="mt-2 flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/2">
              <Images images={this.state?.vehicle?.images || []}/>

              <AuctionType auctionType={auction.round.Type}/>
            </div>

            <div className="flex flex-col md:hidden">
              <Countdown auction={auction} timeTillDate={auction.round.EndsOn} small={true} hotBid={true}/>

              <AuctionPrice auction={auction} small={true}/>
            </div>

            <div className="lg:ml-4 w-full lg:w-1/2 mt-2">
              <div className="w-full font-semibold text-lg px-2 whitespace-pre-wrap break-all">
                {make(this.state.vehicle.Make)} {this.state.vehicle.ShortDescription}
              </div>

              <Attributes vehicle={this.state.vehicle} preAuction={auction.round.PreAuction}/>
            </div>
          </div>

          {
            auction.round.PreAuction ?
              <AlertWarning>
                <p><Trans>Vorab Auktion</Trans></p>
                <p className={"text-xs"}><Trans>Rücktrittsrecht</Trans> – <Trans>Der Verkäufer ist berechtigt, von dem Kaufvertrag zurückzutreten, wenn das Fahrzeug vor der Lieferung aufgrund eines Unfalls oder in sonstiger Weise beschädigt wird. In diesem Fall verpflichtet sich der Verkäufer, den Käufer unverzüglich zu informieren und etwaige, bereits vom Käufer erbrachte Gegenleistungen unverzüglich zu erstatten.</Trans></p>
                <p><Trans>Der Käufer wurde auf die Lieferzeit des Fahrzeugs hingewiesen und akzeptiert diese. Die Beschaffenheit des Fahrzeugs bei Angebotsabnahme ist Grundlage der Annahme des Angebotes.</Trans></p>
                <p><Trans>Sollte der Wagen bis zur Lieferung verunfallen und oder höhere Schäden als 20 % der Angebotssumme aufweisen , behalten wir uns vor, die Annahme des Angebots zu stornieren.</Trans></p>
                <p><Trans>In diesem Fall steht dem Käufer kein Schadensersatzspruch zu.</Trans></p>
              </AlertWarning>
              : null
          }


          {
            this.state.vehicle.Condition ?
              <div className="mt-2">
                <Condition condition={this.state.vehicle.Condition} extra={this.state.vehicle.extra}/>
              </div>
              : null
          }

          <div className="mt-2 md:hidden">
            <div className="border-t border-gray-300 my-4"/>

            <Documents documents={this.state.vehicle.documents}/>
          </div>

          <div className="mt-2">
            <Equipment vehicle={this.state.vehicle}/>
          </div>

          {
            this.state.vehicle.Remarks ?
              <>
                <div className="border-t border-gray-300 my-4"/>
                <div className="mt-2">
                  <Remarks remarks={this.state.vehicle.Remarks}/>
                </div>
              </>
              : null
          }

          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-2">
            <Description longDescription={this.state.vehicle.LongDescription}/>
          </div>

          <div className="mt-2 md:hidden">
            <div className="border-t border-gray-300 my-4"/>

            {useAuctionSettings().showProtocol ? <Protocol history={auction.history}/> : null}
          </div>

          {
            this.settings.legalNotice ?
              <div className="mt-2">
                <div className="border-t border-gray-300 my-4"/>

                <LegalText/>
              </div>
              : null
          }

          <div className="mt-2 md:hidden">
            <IgnoreButton auction={auction} close={this.props.close}/>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  domain: state.user.domain
}))(Details)
